import { connect } from "react-redux";
import CloseRmTicket from "./closeRmTicket";
import { bindActionCreators } from "redux";
import {
  fetchRmTicketDetails,
  postUpdateRMStatus,
  postTicketAssignment,
  postRmRemark,
  getMaterial,
  fetchRmTicketStatus,
  getEquipments,
  generateHappyCode
} from "services/redux/maintenance/rmTicket/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";
import { getSiteData, getDistanceData } from "../../../services/redux/DistanceCalculator/action";

const mapStateToProps = (state) => ({
  pmTicket: state.pmTicketReducer.pmTicket,
  rmTicketDetails: state.rmTicketReducer.rmTicketDetails,
  rmStatus: state.rmTicketReducer.rmStatus,
  materials: state.rmTicketReducer.materials,
  equipments: state.rmTicketReducer.equipments,
  siteData: state.leadDataReducer.siteData,
  distanceDetails: state.leadDataReducer.distanceDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      postUpdateRMStatus,
      documentUploadUrl,
      postRmRemark,
      getMaterial,
      fetchRmTicketStatus,
      fetchRmTicketDetails,
      postTicketAssignment,
      getEquipments,
      getSiteData,
      getDistanceData,
      generateHappyCode
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CloseRmTicket);
